import { parseDate } from "element-ui/src/utils/date-util"
import { setStyle } from "element-ui/src/utils/dom";
import { Message } from "element-ui";

/**
 * 在数字前面补0
 * @param num 数字
 * @param length 将数字不足length位时，补位至 length 长度
 * @returns {string} 补位后的结果
 */
export function padZero(num, length) {
    let len = num.toString().length;
    while (len < length) {
        num = "0" + num;
        len++;
    }
    return num;
}

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
        date = time;
    } else {
        if (typeof time === "string") {
            if (/^[0-9]+$/.test(time)) {
                // support "1548221490638"
                time = parseInt(time);
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), "/");
            }
        }

        if (typeof time === "number" && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
            return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        return value.toString().padStart(2, "0");
    });
    return time_str;
}

/**
 * 将阿拉伯数字处理成中文大写数字，支持到万级
 * toChineseNum(12345)  -> 一万二千三百四十五。
 * @param num
 * @returns {string|string}
 */
export function toChinesNum(num) {
    let changeNum = [
        "零",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九"
    ]; // changeNum[0] = "零"
    let unit = ["", "十", "百", "千", "万"];
    num = parseInt(num);
    let getWan = (temp) => {
        let strArr = temp.toString().split("").reverse();
        let newNum = "";
        for (let i = 0; i < strArr.length; i++) {
            newNum =
                (i === 0 && strArr[i] === "0"
                    ? ""
                    : i > 0 && strArr[i] === "0" && strArr[i - 1] === "0"
                        ? ""
                        : changeNum[strArr[i]] +
                        (strArr[i] === "0" ? unit[0] : unit[i])) + newNum;
        }
        return newNum;
    };
    let overWan = Math.floor(num / 10000);
    let noWan = num % 10000;
    if (noWan.toString().length < 4) noWan = "0" + noWan;
    return overWan ? getWan(overWan) + "万" + getWan(noWan) : getWan(num);
}

export function sleep(time) {
    return new Promise((r) => {
        setTimeout(() => {
            r();
        }, time);
    });
}

export function secFormat(sec) {
    if (sec < 0) {
        return "5秒"
    }
    if (sec <= 60) {
        return sec + "秒"
    }
    let s = sec % 60;
    let m = Math.floor(sec / 60)
    return `${m}分${s}秒`
}

export function uuid(len, radix) {
    let chars =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
            ""
        );
    let uuid = [];
    let i;
    radix = radix || chars.length;
    if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
    } else {
        let r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | (Math.random() * 16);
                // eslint-disable-next-line eqeqeq
                uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
            }
        }
    }

    return uuid.join("");
}

/**
 * 清理值为 null、 undefined 空字符 的参数
 * @param obj 参数对象
 */
export function cleanNoneParam(obj) {
    let param = {};
    for (const objKey in obj) {
        if (obj[objKey] != null && obj[objKey] !== "") {
            param[objKey] = obj[objKey]
        }
    }
    return param;
}

/**
 * 删除数组中item的空children
 * @param list 数组
 * @param childrenKey children的key
 */
export function removeEmptyChildren(list, childrenKey = "Children") {
    list.forEach(el => {
        let children = el[childrenKey]
        if (children) {
            if (children.length > 0) {
                removeEmptyChildren(children, childrenKey)
            } else {
                delete el[childrenKey]
            }
        }
    })
}

export function safeParseInt(string = "0") {
    if (string === true) return 1;
    if (string === false) return 0;
    return parseInt(string || 0)
}

export function nowString() {
    return parseTime(new Date(), "{y}-{m}-{d} {h}:{i}:{s}")
}

const alphabet = [""]
for (let i = 0; i < 24; i++) {
    alphabet.push(String.fromCharCode(65 + i))
}

export { alphabet }

export function treeToArray(arr, children = "children") {
    const result = []
    const fn = (tempArr) => {
        for (const item of tempArr) {
            const {
                [children]: child,
                ...otherData
            } = item
            if (Array.isArray(child) && child.length !== 0) {
                result.push(otherData)
                fn(child)
            } else {
                result.push(otherData)
            }
        }
    }
    fn(arr)
    return result
}

// 获取当前组件下的指定父组件
export function getParent(componentName, realParent) {
    let parent = realParent || this.$parent || this.$root;
    if (!componentName) return parent
    let name = parent.$options.componentName;

    while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
            name = parent.$options.componentName;
        }
    }
    return parent
}

// 去掉所有空格以及换行制表符
export function formatStr(str = "") {
    return str.replace(/\s+/g, "").replace(/(\n|\r|(\r\n)|(\u0085)|(\u2028)|(\u2029))/g, "")
}

function formatTime(date, cformat) {
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    let format
    // 完整时间 {y}-{m}-{d} {h}:{i}:{s}  {a}获取星期几
    if (cformat && cformat !== "time") {
        format = cformat
    } else if (cformat === "time") {
        format = "{y}-{m}-{d} {h}:{i}"
    } else {
        format = "{y}-{m}-{d}"
    }
    return format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
            return ["日", "一", "二", "三", "四", "五", "六"][value]
        }
        return value.toString().padStart(2, "0")
    })
}

/**
 * 仿照微信中的消息时间显示逻辑，将时间戳（单位：毫秒）转换为友好的显示格式.
 *
 * 1）7天之内的日期显示逻辑是：今天、昨天(-1d)、前天(-2d)、星期？（只显示总计7天之内的星期数，即<=-4d）；
 * 2）7天之外（即>7天）的逻辑：直接显示完整日期时间。
 *
 * @param  {number | string} timestamp 时间戳（单位：毫秒），形如：1550789954260
 * @param {boolean} mustIncludeTime true表示输出的格式里一定会包含“时间:分钟”
 * ，否则不包含（参考微信，不包含时分的情况，用于首页“消息”中显示时）
 *
 * @return {string} 输出格式形如：“刚刚”、“10:30”、“昨天 12:04”、“前天 20:51”、“星期二”、“2019/2/21 12:09”等形式
 * @author 即时通讯网([url=http://www.52im.net]http://www.52im.net[/url])
 * @since 1.1
 */
export function timeAgo(timestamp, mustIncludeTime = true) {
    if (typeof timestamp === "string") {
        timestamp = parseDate(timestamp, "yyyy-MM-dd HH:mm:ss").getTime()
    } else if (String(timestamp).length === 10) {
        timestamp *= 1000
    }
    // 当前时间
    var currentDate = new Date()
    // 目标判断时间
    var srcDate = new Date(Number(timestamp))
    var currentYear = currentDate.getFullYear()
    var currentMonth = (currentDate.getMonth() + 1)
    var currentDateD = currentDate.getDate()
    var srcYear = srcDate.getFullYear()
    var srcMonth = (srcDate.getMonth() + 1)
    var srcDateD = srcDate.getDate()
    var ret = ""
    // 要额外显示的时间分钟
    const timeExtraStr = (mustIncludeTime ? " " + formatTime(srcDate, "{h}:{i}") : "");
    // 当年
    if (currentYear == srcYear) {
        var currentTimestamp = currentDate.getTime()
        var srcTimestamp = timestamp
        // 相差时间（单位：毫秒）
        var deltaTime = (currentTimestamp - srcTimestamp)
        // 当天（月份和日期一致才是）
        if (currentMonth == srcMonth && currentDateD == srcDateD) {
            // 时间相差60秒以内
            if (deltaTime < 60 * 1000) {
                ret = "刚刚"
            }// 否则当天其它时间段的，直接显示“时:分”的形式
            else {
                ret = formatTime(srcDate, "{h}:{i}")
            }
        }
        // 当年 && 当天之外的时间（即昨天及以前的时间）
        else {
            // 昨天（以“现在”的时候为基准-1天）
            var yesterdayDate = new Date()
            yesterdayDate.setDate(yesterdayDate.getDate() - 1)

            // 前天（以“现在”的时候为基准-2天）
            var beforeYesterdayDate = new Date()
            beforeYesterdayDate.setDate(beforeYesterdayDate.getDate() - 2)
            // 用目标日期的“月”和“天”跟上方计算出来的“昨天”进行比较，是最为准确的（如果用时间戳差值
            // 的形式，是不准确的，比如：现在时刻是2019年02月22日1:00、而srcDate是2019年02月21日23:00，
            // 这两者间只相差2小时，直接用“deltaTime/(3600 * 1000)” > 24小时来判断是否昨天，就完全是扯蛋的逻辑了）
            if (srcMonth == (yesterdayDate.getMonth() + 1) && srcDateD == yesterdayDate.getDate()) {
                ret = "昨天" + timeExtraStr
            }// -1d
            // “前天”判断逻辑同上
            else if (srcMonth == (beforeYesterdayDate.getMonth() + 1) && srcDateD == beforeYesterdayDate.getDate()) {
                ret = "前天" + timeExtraStr
            }// -2d
            else {
                // 跟当前时间相差的小时数
                var deltaHour = (deltaTime / (3600 * 1000))

                // 如果小于或等 7*24小时就显示星期几
                if (deltaHour <= 7 * 24) {
                    var weekday = new Array(7)
                    weekday[0] = "星期日"
                    weekday[1] = "星期一"
                    weekday[2] = "星期二"
                    weekday[3] = "星期三"
                    weekday[4] = "星期四"
                    weekday[5] = "星期五"
                    weekday[6] = "星期六"
                    // 取出当前是星期几
                    var weedayDesc = weekday[srcDate.getDay()]
                    ret = weedayDesc + timeExtraStr
                }// 否则直接显示完整日期时间
                else {
                    ret = formatTime(srcDate, "{y}-{m}-{d} {h}:{i}")
                }
            }
        }
    }
    // 往年
    else {
        ret = formatTime(srcDate, "{y}-{m}-{d}")
    }
    return ret
}

/**
 * 上传图片
 * @param success { Function } 成功回调
 * @param [fail] { Function } 失败回调
 * @param [accept] { String } 允许上传的文件类型
 * @param [multiple] { Boolean } 是否允许上传多个
 * @return {undefined}
 */
export function uploadOfInput(success, fail, accept = ".jpg,.png,.jpeg", multiple = false) {
    const input = document.createElement("input")
    setStyle(input, "display", "none")
    input.setAttribute("type", "file")
    input.setAttribute("id", "common-upload-file")
    input.setAttribute("accept", accept)
    if (multiple === true) {
        input.setAttribute("multiple", String(multiple))
    }
    document.body.append(input)
    input.click()
    input.onchange = function (file) {
        const files = Array.from(file.target.files)
        console.log(files, "选择的文件-----files");
        const availableArr = accept.split(",")
        const filterFile = files.filter(item => availableArr.includes(item.name.slice(item.name.lastIndexOf("."))))
        if (filterFile.length !== files.length) {
            Message.error("请上传" + accept + "文件")
        }
        if (multiple === true) {
            if (filterFile.length > 0) {
                typeof success === "function" && success(filterFile)
            }
        } else {
            if (filterFile.length === 1) {
                typeof success === "function" && success(filterFile[0])
            }
        }
    }
    input.onerror = function (err) {
        if (typeof fail === "function") {
            fail(err)
        } else {
            console.error(err, "选择文件失败");
            Message.error("上传失败")
        }
    }
    setTimeout(() => {
        document.body.removeChild(input)
    }, 200)
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

/**
 * @param json {Object}
 * @param [prefix] {String}  拼接字符串
 * @param [encrypt] {Boolean}  是否加密
 * @returns {string}
 * json 生成后端需要的序列化字符串
 */
export function param(json, encrypt, prefix = "?") {
    if (!json) return ""
    return prefix + cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ""
            return (encrypt ? encodeURIComponent(key) : key) + "=" + (encrypt ? encodeURIComponent(json[key]) : json[key])
        })
    ).join("&")
}

/**
 * @param [url] {String}
 * @returns {Object}
 * 获取查询字符串并将其转换为对象
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf("?") + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * 在不跳转的情况下设置url中的query参数
 * @param query { Object } query查询参数
 * @return {undefined}
 */
export function setUrlQuery(query) {
    const href = window.location.href;
    const queryToString = param(Object.assign(getQueryObject(href), query), true)
    const fn = (str) => window.history.replaceState({}, "title", str + queryToString);
    const index = href.lastIndexOf("?")
    if (index === -1) return fn(href)
    return fn(href.slice(0, index))
}

/**
 * 数字转大写字母，比如 1=>A 2=>B
 * @param {Number} number
 * @return {String}
 */
export function numberToWord(number) {
    let s = "";
    while (number > 0) {
        let m = number % 26;
        m = m === 0 ? (m = 26) : m;
        s = String.fromCharCode(64 + m) + s;
        number = (number - m) / 26;
    }
    return s;
}

/**
 * 判断传入值是否为空
 * @param {any} val
 * @return {Boolean}
 */
export function isEmpty(val) {
    // null or undefined
    if (val == null) return true;

    if (typeof val === "boolean") return false;

    if (typeof val === "number") return !val;

    if (val instanceof Error) return val.message === "";

    switch (Object.prototype.toString.call(val)) {
    // String or Array
    case "[object String]":
    case "[object Array]":
        return !val.length;
        // Map or Set or File
    case "[object File]":
    case "[object Map]":
    case "[object Set]": {
        return !val.size;
    }
    // Plain Object
    case "[object Object]": {
        return !Object.keys(val).length;
    }
    }
    return false;
}

/**
 * 传入指定格式，生成固定格式的时间
 * @returns {String}
 * @param mode
 * @param s 秒数
 */
export function getTimerStr(s, mode) {
    const formatObj = {
        h: Math.floor(s / 3600),
        i: mode.includes("{h}") ? Math.floor(s % 3600 / 60) : Math.floor(s / 60),
        s: mode.includes("{h}") ? Math.floor(s % 3600 % 60) : mode.includes("{i}") ? Math.floor(s % 60) : s
    }
    return mode.replace(/{([his])+}/g, (result, key) => {
        return formatObj[key].toString().padStart(2, "0")
    })
}

/** 重写number的toFixed方法，解决精度丢失的问题
 *  @param {Number} num 转换的num数字
 *  @param {Number} n 当输入整数时返回整数自动添加小数位
 *  @returns {String}
 */
export function toFixed(num, n) {
    if (n > 20 || n < 0) {
        throw new RangeError("toFixed() digits argument must be between 0 and 20")
    }
    const number = num
    if (isNaN(number) || number >= Math.pow(10, 21)) {
        return number.toString()
    }
    if (typeof (n) === "undefined" || n === 0) {
        return (Math.round(number)).toString()
    }
    let result = number.toString()
    const arr = result.split(".")
    // 整数的情况
    if (arr.length < 2) {
        result += "."
        for (let i = 0; i < n; i += 1) {
            result += "0"
        }
        return result
    }
    const integer = arr[0]
    const decimal = arr[1]
    if (decimal.length === n) {
        return result
    }
    if (decimal.length < n) {
        for (let i = 0; i < n - decimal.length; i += 1) {
            result += "0"
        }
        return result
    }
    result = integer + "." + decimal.substr(0, n)
    const last = decimal.substr(n, 1)
    // 四舍五入，转换为整数再处理，避免浮点数精度的损失 正数+1 负数-1
    if (parseInt(last, 10) >= 5) {
        const x = Math.pow(10, n)
        result = (Math.round((parseFloat(result) * x)) + (parseFloat(result) > 0 ? 1 : -1)) / x
        result = result.toFixed(n)
    }
    return result
}

// 获取视频相关信息
export function getVideoInfo(file, callBack, isUrl) {
    const video = document.createElement("video");
    video.setAttribute("crossOrigin", "anonymous") // 处理跨域
    video.setAttribute("src", isUrl ? file : URL.createObjectURL(file))
    video.currentTime = 1
    video.addEventListener("loadeddata", function() {
        const canvas = document.createElement("canvas");
        // 使用视频的宽高作为canvas、预览图的宽高
        const width = video.videoWidth;
        const height = video.videoHeight;
        canvas.width = width
        canvas.height = height
        canvas.getContext("2d").drawImage(video, 0, 0, width, height) // 绘制canvas
        // blob形式
        canvas.toBlob((blob) => {
            const file = new File([blob], "poster.png", { type: blob.type })
            // 时长 this.duration
            typeof callBack === "function" && callBack(file, this)
        }, "image/png", 0.4)
    })
}

// 手动销毁组件
export function removeKeepAliveCacheForVueInstance(vueInstance) {
    let key =
        vueInstance.$vnode.key ||
        vueInstance.$vnode.componentOptions.Ctor.cid + (vueInstance.$vnode.componentOptions.tag ? `::${vueInstance.$vnode.componentOptions.tag}` : "");
    let cache = vueInstance.$vnode.parent.componentInstance.cache;
    let keys = vueInstance.$vnode.parent.componentInstance.keys;
    if (cache[key]) {
        vueInstance.$destroy();
        delete cache[key];
        let index = keys.indexOf(key);
        if (index > -1) {
            keys.splice(index, 1);
        }
    }
}

// 清除对象中的空字符串
export function clearObjEmptyStr (params) {
    if (Object.isObj(params)) {
        Object.keys(params).forEach(key => {
            if (params[key] === "") params[key] = undefined
        })
        return params
    }
}

/**
 * @description 验证是否是手机号
 * @param {string} str - 要显示的文字
 * @return {undefined}
 */
export function validatePhoneNumber (str) {
    const phoneNumber = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/ /* 可以为空单只能输入正确的手机号 */
    return phoneNumber.test(String(str))
}

/**
 * 将树结构转为扁平化列表
 * @param {Array<Object>} tree - 转换的树结构
 * @param [childrenKey] 子集的key
 * @param [result]
 * @param [level]
 * @return {Array}
 */
export function treeConvertList(tree, childrenKey, result, level) {
    result = result || []
    childrenKey = childrenKey || "children"
    if (Array.isArray(tree) && tree.length) {
        tree.forEach(node => {
            node.level = (level || 0) + 1
            result.push(node)
            treeConvertList(node[childrenKey], childrenKey, result, level)
        })
    }
    return result
}
